import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {extractDataFromModel} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {isNullOrUndefined} from 'util';
import {StyleType} from "@catui/types";
import {DisplayType} from "@catuiform/types";

@Component({
  selector: 'catapp-modify-playlist',
  templateUrl: './modify-playlist.component.html',
  styleUrls: ['./modify-playlist.component.scss'],
})
export class ModifyPlaylistComponent implements OnInit {

  @Input() title: string;
  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<any>();

  @Input() displayDelete = true;
  @Input()
  get model(): any {
    return this._model;
  }

  set model(value: any) {
    this._model = value;
    if (!isNullOrUndefined(value)) {

      this.avod_catalog = extractDataFromModel(value, 'avod_catalog');
      this.form.patchValue({
        name: value.name,
        avod_catalog: this.avod_catalog.label,
        path: value.path,
        sync: value.sync_with_settings,
      });
    }
  }

  get dataIsReady() {
    const isReady = !isNullOrUndefined(this._model);
    return isReady;
  }

  labels = {
    name: 'Name',
    avodCatalog: 'AVoD Catalog',
    path: 'Path',
    sync: 'Sync with Settingsserver',
  };

  controlRefs = {
    name: 'name',
    avodCatalog: 'avod_catalog',
    path: 'path',
    sync: 'sync',
  };

  form: FormGroup;
  styleType = StyleType;
  displayTypes = DisplayType;

  private _model;
  private avod_catalog;

  constructor(private genericResourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      name: this.formBuilder.control('', []),
      avod_catalog: this.formBuilder.control('', []),
      path: this.formBuilder.control('', []),
      sync: this.formBuilder.control('', []),
    });
  }

  ngOnInit() {
  }

  update() {
    const service = this.genericResourceService.findServiceForResource(this._model._links.self.href);
    let data = this.form.value;
    delete data.avod_catalog;
    service
      .save(data)
      .subscribe(() => {
        this.afterUpdate.emit();
        this.activeModal.close(this._model);
      })
    ;
  }

  /**
   * Initialize a request to delete the current FeaturePortConnection
   */
  delete() {
    const service = this.genericResourceService.findServiceForResource(this._model._links.self.href);
    console.warn(service);
    service
      .delete()
      .subscribe(() => {
        this.afterDelete.emit();
        this.activeModal.close();

      });

  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/modify-playlist/modify-playlist.component.ts